import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Button } from "../../components/ui/button";
import { LayoutDashboard, Users, ShieldCheck, FileVideo, Flag, LogOut, ArrowLeft } from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/verifications", label: "Verifications", icon: ShieldCheck },
  { to: "/admin/content", label: "Content", icon: FileVideo },
  { to: "/admin/reports", label: "Reports", icon: Flag },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-background text-foreground flex">
      <aside className="hidden lg:flex flex-col w-[260px] shrink-0 border-r border-border sticky top-0 h-screen">
        <div className="px-6 py-6 border-b border-border">
          <div className="brand-mark text-3xl leading-none">
            Truebate<span className="text-[hsl(var(--primary))]">.</span>
          </div>
          <div className="label-mono text-muted-foreground mt-2">Admin console</div>
        </div>
        <nav className="flex-1 py-4">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-3 label-mono transition-colors ${
                  isActive ? "bg-foreground text-background" : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                }`
              }
            >
              <Icon className="w-4 h-4" />{label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-4 space-y-2">
          <div className="label-mono text-muted-foreground truncate">@{user?.username}</div>
          <Button onClick={() => navigate("/home")} variant="outline" className="w-full rounded-sm label-mono" data-testid="admin-user-view">
            <ArrowLeft className="w-3 h-3 mr-1" /> User view
          </Button>
          <Button onClick={handleLogout} variant="outline" className="w-full rounded-sm label-mono" data-testid="admin-logout">
            <LogOut className="w-3 h-3 mr-1" /> Sign out
          </Button>
        </div>
      </aside>

      {/* Mobile header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-background border-b border-border">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="brand-mark text-2xl">Truebate<span className="text-[hsl(var(--primary))]">.</span></div>
          <div className="label-mono text-muted-foreground text-[10px]">Admin</div>
        </div>
        <div className="flex overflow-x-auto border-t border-border">
          {nav.map(({ to, label, end }) => (
            <NavLink key={to} to={to} end={end} className={({isActive}) => `label-mono px-4 py-2 whitespace-nowrap ${isActive ? "bg-foreground text-background" : "text-muted-foreground"}`}>
              {label}
            </NavLink>
          ))}
        </div>
      </div>

      <main className="flex-1 min-w-0 pt-24 lg:pt-0">
        <Outlet />
      </main>
    </div>
  );
}
